import React, { Component } from "react";
import "./SideBar.scss";
import { shareFacebook, shareWhatsapp, openNegishut, shareTwitter } from "../Services/Sharing";
import { __AreasMenuLabel__, __CurrentAreas__ } from "../Helpers/ArrayGrouping";
import { InnerCard } from "../Helpers/CardHelper";
import { GA_Push } from "../Services/GoogleAnalytics";
import Footer from "../Footer/Footer";

export default class SideBar extends Component {
    constructor() {
        super();
        this.toggleMenu = this.toggleMenu.bind(this);
        this.openSharer = this.openSharer.bind(this);
        this.renderAreas = this.renderAreas.bind(this);
        this.renderContent = this.renderContent.bind(this);
        this.list = [];
        this.state = {
            isSharer: false,
            toggleMenu: false,
            currentPin: 0
        }
    }
    componentDidMount() {
        window.addEventListener("pinClicked", (event) => {
            this.setState({
                currentPin: event.detail
            })
        });
    }
    toggleMenu() {
        this.setState({
            toggleMenu: !this.state.toggleMenu
        })
    }
    openSharer() {
        this.setState({
            isSharer: !this.state.isSharer
        })
    }
    clickCard(card) {
        ((callback) => {
            GA_Push("Read_More_Menu_Clicked", card.Title);
            window.setTimeout(callback, 50);
        })(window.open(card.Link, "_blank"));
    }
    renderContent(index) {
        let list = [];

        __CurrentAreas__(index).map((card, index) =>
            list.push(
                <InnerCard key={index} index={index}
                    {...card}
                    onClick={this.clickCard}
                />));
        return list;
    }
    renderAreas() {
        let list = [];
        __AreasMenuLabel__().map((item, index) => {
            list.push(
                <li
                    className={`option ${this.state.currentPin == item.Order ? " active" : ""}`}
                    key={index}
                    ref={list => this.list[index] = list}
                    onClick={() => {
                        if (this.state.currentPin == index + 1) {
                            this.setState({
                                currentPin: 0
                            })
                            return;
                        }
                        this.mContent.scrollTop = 0;
                        GA_Push("Continent_Clicked", item.Mainland + " - SideBar");
                        window.setTimeout(() => this.list[index].scrollIntoView(), 50);
                        this.setState({
                            currentPin: index + 1,
                            toggleMenu: true
                        }, () => {
                            // window.dispatchEvent(new CustomEvent("menuPinClicked", {
                            //     "detail": index + 1
                            // }));
                        })
                    }}
                >
                    {item.Mainland}
                    <div className="mobilecontent">
                        {this.renderContent(index + 1)}
                    </div>
                </li>
            );
        })
        return list;
    }
    render() {
        return (
            <div id="sidebar" className={`${this.state.toggleMenu ? " active" : ""}`}>
                <div className="fade" onClick={this.toggleMenu}></div>
                <menu>
                    <div className="side-container">
                        <a href="https://www.ynet.co.il/" target="_blank" title="YNET"><div className="ynet"></div></a>
                        <div className="menubtn" onClick={this.toggleMenu}>
                            <div className="line"></div>
                        </div>
                        <InnerShares
                            className="navbar"
                            shareFacebook={shareFacebook}
                            shareTwitter={shareTwitter}
                            shareWhatsapp={shareWhatsapp}
                            openNegishut={openNegishut}
                            openSharer={this.openSharer}
                            isSharer={this.state.isSharer}
                        />
                    </div>
                </menu>
                <div className="overflow">
                    <div className="hidden">
                        <div className="close" onClick={this.toggleMenu}></div>
                        <div className="of-container">
                            <div className="label">בחר אזור</div>
                            <div className="con-flex">
                                <div className="menu-areas">
                                    <ul>
                                        {this.renderAreas()}
                                    </ul>
                                </div>
                                <div className="menu-content" ref={mContent => this.mContent = mContent}>
                                    {this.state.currentPin > 0 ? this.renderContent(this.state.currentPin) : ""}
                                </div>
                            </div>
                        </div>
                        <Footer id="footermenu" />
                    </div>
                </div>
            </div>
        )
    }
}

const InnerShares = props => {
    return (
        <div className={`share ${props.className ? props.className : ""}`}>
            <div className={`share-flex ${props.isSharer ? " active" : ""}`}>
                <div onClick={props.openNegishut} className="negishut"></div>
                <div onClick={props.openSharer} className="sharer"></div>
                <div onClick={props.shareFacebook} className="facebook"></div>
                <div onClick={props.shareWhatsapp} className="whatsapp"></div>
            </div>
        </div>
    )
}


// WEBPACK FOOTER //
// ./src/Components/SideBar/SideBar.jsx